<template>
  <div
    class="
      sidebar-member
      d-flex
      justify-content-space-between
      flex-column
      no-padding
    "
  >
    <v-col>
      <v-row class="justify-space-between col-md-12">
        <div class="">
          <v-menu bottom left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn dark icon v-bind="attrs" v-on="on">
                <svg
                  width="22"
                  height="14"
                  viewBox="0 0 22 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 13H20.5"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M1 7H20.5"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M1 1H20.5"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </v-btn>
            </template>

            <v-list>
              <v-list-item v-for="(item, i) in items" :key="i">
                <v-list-item-title
                  v-if="item.title != 'Account'"
                  @click="changePage(item.url)"
                  >{{ item.title }}</v-list-item-title
                >
                <div v-else>
                  <v-list-item-title class="mt-4">Account</v-list-item-title>
                  <v-list-item
                    v-for="(child, i) in item.children"
                    :key="i"
                    link
                    @click="changePage(child.url)"
                  >
                    <svg
                    class="mr-3"
                      width="8"
                      height="8"
                      viewBox="0 0 8 8"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3.71429 6.28544C5.13445 6.28544 6.28572 5.13417 6.28572 3.71401C6.28572 2.29385 5.13445 1.14258 3.71429 1.14258C2.29413 1.14258 1.14286 2.29385 1.14286 3.71401C1.14286 5.13417 2.29413 6.28544 3.71429 6.28544Z"
                        stroke="#555555"
                        stroke-width="1.71429"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    {{ child.title }}
                  </v-list-item>
                </div>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
        <div class="text-end">
          <img src="/apple-logo.png" alt="" />
        </div>
      </v-row>
    </v-col>
    <v-col class="middle-sidebar" v-if="!$store.getters.verifyUser">
      <h2 class="white--text font sidebar-title">
        {{ title }}
      </h2>
    </v-col>
    <v-col>
      <h2 class="paragraphs font">
        {{ desc }}
      </h2>
    </v-col>
    <v-col class="end-sidebar">
      <span class="white--text font">
        Copyright (c)  {{ new Date().toLocaleString() | moment("YYYY")}} - Apaly Health Inc
      </span>
    </v-col>
  </div>
</template>
<script>
export default {
  data() {
    return {
      items: [
        {
          title: "Home",
          url: "/family-members/home",
        },
        {
          title: "Family Members",
          url: "/family-members/family",
        },
        {
          title: "Visit Passes",
          url: "/family-members/visit-passes",
        },
        {
          title: "Find Care",
          url: "/family-members/care",
        },
        {
          title: "Contact Us",
          url: "/family-members/contact",
        },
        {
          title: "Account",
          url: "/family-members/account",
          children: [
            {
              title: "Personal Info",
              url: "/family-members/account/info",
            },
            {
              title: "Billing & payment",
              url: "/family-members/account/payment",
            },
            {
              title: "Settings",
              url: "/family-members/account/settings",
            },
          ],
        },
      ],
      icons: ["mdi-home", "mdi-email", "mdi-calendar", "mdi-delete"],
      padless: false,
      whoYouAreTitle: "Tell us who you are",
      showMenuList: false,
      whoYouAreP:
        "We'll quide you throught our simple sing up process so that you can easily experiance the benefits of Apaly Health's employer and provider collaboration platform",
      aboutYouTitle: "Tell us about you",
    };
  },
  computed: {
    title() {
      let str;
      let path = this.$route.path;
      if (path == "/login") {
        str = "Direct Healthcare.";
      } else if (path == "/select-type") {
        str = "Tell us who you are.";
      } else {
        str = this.$store.state.sideBarTitle;
      }

      return str;
    },
    desc() {
      let str;
      let path = this.$route.path;
      if (path == "/login") {
        str = "";
      } else if (path == "/select-type") {
        str =
          "We'll guide you throught our simple sing up process so that you can easily experience the benefits of Apaly Helath";
      } else {
        str = this.$store.state.sideBarDesc;
      }

      return str;
    },
  },
  props: {},
  methods: {
    changePage(url) {
      this.$router.push(url);
    },
  },
};
</script>
<style>
.sidebar-member {
  background: #032554 !important;
  height: 30vh;

  overflow: scroll;
}
</style>